import { displayDate, displayTime } from '@adsk/alloy-react-datetime';

// for announcement banner, we want to show date and time in US locale ONLY - for other cases please use the official displayDate & displayTime
export const formatAnnouncementDateAndTime = (date: string | Date) => {
  const dateToFormat = new Date(date);
  const formattedDate = displayDate(dateToFormat, {
    locale: 'en-US',
    year: false,
    weekday: true,
  });
  const formattedTime = displayTime(dateToFormat, {
    locale: 'en-US',
  });

  return `${formattedDate} ${formattedTime}`;
};
